import VueRoutes from '@/types/VueRoutes';

import routes from './routes';
import router from './index';

const vueRoutes = new VueRoutes(router);
vueRoutes.addRoutes(routes);

export default vueRoutes;
